module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/main-05cf7cdf7e21f0e46f400f02611b28ae.jpg";